"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var NominalContrasts_1 = require("../utils/NominalContrasts");
var meetsContrast_1 = require("../utils/meetsContrast");
var areColorsEqual_1 = __importDefault(require("../utils/areColorsEqual"));
var MIN_REQUIRED_CONSTRAST = 1.5;
/**
 * Prefered avatar color is primary, unless primary does not provide reasonable contrast.
 * In that case, use the action color if it provides reasonable contrast, but only if action did not resolve to white or black.
 * If action is white or black, use the secondary color minimum contrast is met.
 * In all other cases use accent.
 */
function getAvatarStyles(theme) {
    var backgroundColor = theme.backgroundColor, font = theme.font, block = theme.block, palette = theme.palette;
    var action = backgroundColor.click.base;
    if (!action || !(palette === null || palette === void 0 ? void 0 : palette.primary) || !(palette === null || palette === void 0 ? void 0 : palette.secondary) || !(block === null || block === void 0 ? void 0 : block.accent) || !(block === null || block === void 0 ? void 0 : block.base)) {
        return null;
    }
    var avatarBackgroundColor = block.accent;
    if ((0, meetsContrast_1.meetsContrastWithBlockShades)(palette.primary, block, MIN_REQUIRED_CONSTRAST)) {
        avatarBackgroundColor = palette.primary;
    }
    else if ((0, meetsContrast_1.meetsContrastWithBlockShades)(action, block, MIN_REQUIRED_CONSTRAST) &&
        !(0, areColorsEqual_1.default)(action, font.color.base)) {
        avatarBackgroundColor = action;
    }
    else if ((0, meetsContrast_1.meetsContrastWithBlockShades)(palette.secondary, block, MIN_REQUIRED_CONSTRAST)) {
        avatarBackgroundColor = palette.secondary;
    }
    var isOnLight = (0, NominalContrasts_1.isLightColor)(avatarBackgroundColor);
    var fontOnLight = block.isLight ? font.color.base : font.color.fill;
    var fontOnDark = block.isDark ? font.color.base : font.color.fill;
    var baseMeetsContrast = (0, meetsContrast_1.meetsContrast)(font.color.base, avatarBackgroundColor);
    var fillMeetsContrast = (0, meetsContrast_1.meetsContrast)(font.color.fill, avatarBackgroundColor);
    var preferedFontColor;
    if (palette.preferFormula && baseMeetsContrast && fillMeetsContrast) {
        preferedFontColor = palette.preferFormula === 'light' ? fontOnLight : fontOnDark;
    }
    var selectedFontColor = preferedFontColor !== null && preferedFontColor !== void 0 ? preferedFontColor : (isOnLight ? fontOnLight : fontOnDark);
    return {
        background: { backgroundColor: avatarBackgroundColor },
        text: { color: selectedFontColor }
    };
}
exports.default = getAvatarStyles;
//# sourceMappingURL=getAvatarStyles.js.map